Namespace 'Customer.Dashboard'

class Customer.Dashboard.SummaryTicketsExportableFieldsView extends Backbone.View
  template: JST['backbone/templates/customer/dashboard/summary/main/summary_exportable_fields']
  sectionTemplate: JST['backbone/templates/customer/dashboard/summary/main/exportable_fields_section']

  events:
    'click .export-confirm': 'onClickExport'
    'click .export-json': 'onClickJsonExport'
    'click .exportable-fields-option': 'toggleExportableFieldsOption'
    'click .field-name .switch :checkbox': 'toggleAllLevelsSwitch'
    'click .field-name .switch #social_user:checkbox': 'toggleSocialUserSwitch'
    'click .switch-category': 'toggleCategorySwitches'

  initialize: (@options = {}) ->
    @filterCount = @options.filterCount
    @exportableFields = @options.exportableFields
    @ticketAttributes = @options.ticketAttributes

  render: ->
    @$el.html @template
      filter_count: @filterCount
    @_addSection
      fields: @exportableFields
      sectionTitle: I18n.t 'customer.dashboard.modal_export_fields.exportable_fields'
      sectionId: 'exportable_fields'
    @_addSection
      fields: @ticketAttributes
      sectionTitle: I18n.t 'customer.dashboard.modal_export_fields.conversation_attributes'
      sectionId: 'conversation_attributes'
    @

  _addSection: ({fields, sectionTitle, sectionId}) =>
    visibleFields = @_visibleFields(fields)
    socialUserFields = @_socialUserFields(fields)
    section = $('<div></div>')
    section.addClass('advanced-options-body')
    section.html @sectionTemplate
      fields: visibleFields
      socialUserFields: socialUserFields
      title: sectionTitle
      id: sectionId
      isSocialUser: @_isSocialUser
      isHierarchicalTags: @_isHierarchicalTags
    @$('.first-exportable-fields-list').append(section)

  toggleExportableFieldsOption: =>
    if @$('.exportable-fields-list:first').is(':hidden')
      @$('.caret-hide-unhide').removeClass('fa-caret-down').addClass('fa-caret-up')
      @$('.exportable-fields-list').slideDown('fast')
    else
      @$('.caret-hide-unhide').removeClass('fa-caret-up').addClass('fa-caret-down')
      @$('.exportable-fields-list').slideUp('fast')

  selectedFrom: (selectableFields) ->
    selectedFields = @_selectedField(field) for field in selectableFields when @_isSelected(field.code) && @_isSocialUserFieldAvailable(field.code)

  _isSocialUserFieldAvailable: (fieldCode) ->
    return false if fieldCode == 'social_user'
    return true if fieldCode not in @_socialUserFieldCodes()
    @_isSelected('social_user')

  _isSelected: (fieldCode) ->
    @$('#' + fieldCode)[0] && @$('#' + fieldCode)[0].checked

  _selectedField: (field) ->
    return @_hierarchicalTagsSelectedField(field) if @_isHierarchicalTags(field)
    field

  _hierarchicalTagsSelectedField: (field) ->
    _.extend {}, field, show_all_levels: @_isSelected("all-levels-#{field.code}")

  _isHierarchicalTags: (field) ->
    field.type is 'attribute' and field.attribute_type is 'HierarchicalTags'

  _isSocialUser: (field) ->
    field.type is 'exportable' and field.code is 'social_user'

  onClickExport: (event) =>
    event.stopPropagation()
    @trigger 'on-export-confirm'
    swal
      title: I18n.t 'customer.dashboard.modal_export_fields.export_started_title'
      text: I18n.t 'customer.dashboard.modal_export_fields.export_started_message'
      type: 'info'

  onClickJsonExport: (event) =>
    event.stopPropagation()
    @trigger 'on-json-export-confirm'
    swal
      title: I18n.t 'customer.dashboard.modal_export_fields.export_started_title'
      text: I18n.t 'customer.dashboard.modal_export_fields.export_started_message'
      type: 'info'

  showModal: =>
    @$('#exportable-fields-modal').modal()

  toggleAllLevelsSwitch: (event) ->
    isSelected = $(event.target).is ':checked'
    sectionId = $(event.currentTarget).data('section')
    $allLevelsSwitch = $(event.target).closest('.field-name').find('.sub-field').find('input.all-levels')
    $allLevelsSwitch.prop('checked', false) unless isSelected
    $allLevelsSwitch.prop('disabled', not isSelected)
    @_validateSwitchCategory(sectionId)
    true

  toggleSocialUserSwitch: (event) ->
    isSelected = $(event.target).is ':checked'
    sectionId = $(event.currentTarget).data('section')
    $socialUserAttributes = $(event.target).closest('.field-name').find('.sub-field').find('input.attribute-checkbox')
    $socialUserAttributes.prop('checked', isSelected)
    $socialUserAttributes.prop('disabled', not isSelected)
    @_validateSwitchCategory(sectionId)
    true

  toggleCategorySwitches: (event) ->
    switchElement = $(event.currentTarget)
    categoryIsChecked = $(switchElement).find('.select-category-switches').hasClass('d-none')
    sectionId = $(switchElement).data('section')
    if categoryIsChecked
      @_categorySwitchShowSelectedText(switchElement)
      @_checkAllCategorySwitches(sectionId, false)
    else
      @_categorySwitchShowUnselectedText(switchElement)
      @_checkAllCategorySwitches(sectionId, true)

  _categorySwitchShowSelectedText: (switchElement) =>
    @$el.find(switchElement).find('.select-category-switches').removeClass('d-none')
    @$el.find(switchElement).find('.unselect-category-switches').addClass('d-none')

  _categorySwitchShowUnselectedText: (switchElement) =>
    @$el.find(switchElement).find('.unselect-category-switches').removeClass('d-none')
    @$el.find(switchElement).find('.select-category-switches').addClass('d-none')

  _checkAllCategorySwitches: (sectionId, state) =>
    @$el.find(sectionId).find('.field-name .switch :checkbox').prop('checked', state)

  _validateSwitchCategory: (sectionId) =>
    switchElement = @$el.find("label[data-section='#{sectionId}']")
    categoryCheckboxes = @$el.find(sectionId).find('.field-name .switch :checkbox')
    allAreChecked = _.every(categoryCheckboxes, (checkbox) => @$el.find(checkbox).is(':checked'))
    if allAreChecked
      @_categorySwitchShowUnselectedText(switchElement)
    else
      @_categorySwitchShowSelectedText(switchElement)

  _visibleFields: (fields) =>
    _.filter(fields, (field) => field.code not in @_socialUserFieldCodes())

  _socialUserFields: (fields) =>
    _.filter(fields, (field) => field.code in @_socialUserFieldCodes())  

  _socialUserFieldCodes: =>
    ['username', 'social_network_user_id', 'social_network_author_name']
